import { call, put, select, takeLatest } from "redux-saga/effects";
import { workflowCatalogApi } from "../../../api/apiLists/workflow";
import {
  fetchWorkflowCatalogFailure,
  fetchWorkflowCatalogRequest,
  fetchWorkflowCatalogStart,
  fetchWorkflowCatalogSuccess
} from "../../slices/workflow";
import { callWorkflowApi, requireWhatsAppModuleAccess } from "./workflowSagaHelper";

const CACHE_DURATION = 10 * 60 * 1000; // 10 minutes

function* handleFetchWorkflowCatalog(action) {
  if (!(yield call(requireWhatsAppModuleAccess))) return;

  try {
    const state = yield select((s) => s.workflowCatalog);
    const now = Date.now();

    if (state?.lastUpdated && state?.data && now - state.lastUpdated < CACHE_DURATION) {
      return;
    }

    yield put(fetchWorkflowCatalogStart());

    const req = action.payload || {
      operation: "GET_CATALOG",
      payload: { catalogType: "all", channel: ["whatsapp"] }
    };

    const res = yield callWorkflowApi(workflowCatalogApi, req);

    if (res?.status) {
      yield put(fetchWorkflowCatalogSuccess(res.data));
      return;
    }

    yield put(fetchWorkflowCatalogFailure(res?.errMsg || "Failed to load workflow catalog"));
  } catch (error) {
    yield put(fetchWorkflowCatalogFailure(error.message || "Failed to load workflow catalog"));
  }
}

export default function* workflowCatalogSaga() {
  yield takeLatest(fetchWorkflowCatalogRequest.type, handleFetchWorkflowCatalog);
}
